import { Icon } from '@iconify/react';
import type { IconifyIcon } from '@iconify/types';
import type { SVGProps } from 'react';
import addCircle from '@iconify-icons/solar/add-circle-linear';
import altArrowRight from '@iconify-icons/solar/alt-arrow-right-linear';
import arrowLeft from '@iconify-icons/solar/arrow-left-linear';
import arrowRight from '@iconify-icons/solar/arrow-right-linear';
import bolt from '@iconify-icons/solar/bolt-linear';
import checkCircle from '@iconify-icons/solar/check-circle-linear';
import clockCircle from '@iconify-icons/solar/clock-circle-linear';
import closeCircle from '@iconify-icons/solar/close-circle-linear';
import download from '@iconify-icons/solar/download-linear';
import flame from '@iconify-icons/solar/flame-linear';
import history from '@iconify-icons/solar/history-linear';
import home from '@iconify-icons/solar/home-2-linear';
import infoCircle from '@iconify-icons/solar/info-circle-linear';
import minusCircle from '@iconify-icons/solar/minus-circle-linear';
import pause from '@iconify-icons/solar/pause-linear';
import play from '@iconify-icons/solar/play-linear';
import refresh from '@iconify-icons/solar/refresh-linear';
import settings from '@iconify-icons/solar/settings-linear';
import stars from '@iconify-icons/solar/stars-linear';
import stopwatch from '@iconify-icons/solar/stopwatch-linear';
import widget from '@iconify-icons/solar/widget-2-linear';

export type SolarIconProps = Omit<SVGProps<SVGSVGElement>, 'color' | 'height' | 'mode' | 'onLoad' | 'rotate' | 'width'> & { size?: number | string };
export type IconifyMarkProps = Omit<SVGProps<SVGSVGElement>, 'color' | 'height' | 'mode' | 'onLoad' | 'rotate' | 'width'> & { name: string; size?: number | string };

function SolarIcon({ icon, size = 18, ...props }: SolarIconProps & { icon: IconifyIcon }) {
  return <Icon icon={icon} width={size} height={size} aria-hidden="true" {...props} />;
}

export function IconifyMark({ name, size = 18, ...props }: IconifyMarkProps) {
  return <Icon icon={name} width={size} height={size} aria-hidden="true" {...props} />;
}

const icon = (iconData: IconifyIcon) => (props: SolarIconProps) => <SolarIcon icon={iconData} {...props} />;

export const Add = icon(addCircle);
export const ArrowLeft = icon(arrowLeft);
export const ArrowRight = icon(arrowRight);
export const Bolt = icon(bolt);
export const Check = icon(checkCircle);
export const ChevronRight = icon(altArrowRight);
export const Clock3 = icon(clockCircle);
export const Download = icon(download);
export const Flame = icon(flame);
export const History = icon(history);
export const Home = icon(home);
export const Info = icon(infoCircle);
export const Minus = icon(minusCircle);
export const Pause = icon(pause);
export const Play = icon(play);
export const Refresh = icon(refresh);
export const Settings = icon(settings);
export const Stars = icon(stars);
export const Stopwatch = icon(stopwatch);
export const Widget = icon(widget);
export const Close = icon(closeCircle);
export const Plus = Add;
export const RotateCcw = Refresh;
export const Settings2 = Settings;
export const Sparkles = Stars;
export const TimerReset = Stopwatch;
export const X = Close;
export const Zap = Bolt;
